import React, { Fragment, useState, useEffect, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";

import OptionalFieldMenu from "./OptionalFieldMenu";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";

const useStyles = makeStyles(theme => ({
  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "400px",
    overflow: "hidden",
    zIndex: 1001,
  },

  list: {
    height: "390px",
  },
}));

const OptionalFieldDropDown = props => {
  const classes = useStyles();
  const { disableButton, handleItemClick, optionalFields } = props;

  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const closeMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };

  const handleListKeyDown = event => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenu(false);
    }
  };

  const prevOpen = useRef(openMenu);
  useEffect(() => {
    if (prevOpen.current === true && openMenu === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openMenu;
  }, [openMenu]);

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        variant="outlined"
        color="primary"
        onClick={toggleMenu}
        aria-controls={openMenu ? `add-optional-fields` : undefined}
        aria-haspopup="true"
        disableRipple
        disabled={disableButton}
        style={{
          backgroundColor: openMenu && "rgba(0, 0, 0, 0.04)",
        }}
      >
        Add Optional Field
      </Button>
      <Menu
        open={openMenu}
        onClose={closeMenu}
        anchorEl={anchorRef.current}
        id={`add-optional-fields`}
        onKeyDown={handleListKeyDown}
        classes={{
          paper: classes.menu,
        }}
        MenuListProps={{
          classes: {
            root: classes.list,
          },
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div>
          <OptionalFieldMenu
            optionalFields={optionalFields}
            handleItemClick={handleItemClick}
          />
        </div>
      </Menu>
    </Fragment>
  );
};

export default OptionalFieldDropDown;
